document.addEventListener('DOMContentLoaded', function() {
  const THRESHOLD = 5000; // 50,00 € in Cent
  const messageContainer = document.querySelector('.free-shipping-message-footer');
  if (!messageContainer) return;

  const costEl = messageContainer.querySelector('span.shipping-costs');
  const freeEl = messageContainer.querySelector('span.free-shipping-price');
  const customerCountry = messageContainer.dataset.customerCountry;

  function updateShippingMessage() {
    const cartSubtotal = parseInt(messageContainer.dataset.cartSubtotal, 10);

    if (customerCountry === 'DE') {
      if (cartSubtotal >= THRESHOLD) {
        // ab 50 €: alte Kosten durchstreichen, gratis anzeigen
        costEl.classList.add('strikethrough');
        freeEl.style.display = 'inline';
      } else {
        // unter 50 €: nur alte Kosten, kein Gratis-Text
        costEl.classList.remove('strikethrough');
        freeEl.style.display = 'none';
      }
    } else {
      // für andere Länder: einfach ausblenden oder Standard behandeln
      costEl.classList.remove('strikethrough');
      freeEl.style.display = 'none';
    }
  }

  // Initial
  updateShippingMessage();

  // Debug-Log
  console.log('Shipping message handler initialized, threshold =', THRESHOLD);

  // bei Cart-Updates neu berechnen
  document.addEventListener('cart:updated', function(event) {
    console.log('Cart updated:', event.detail);
    if (messageContainer && event.detail.cart) {
      messageContainer.dataset.cartSubtotal = event.detail.cart.total_price;
      updateShippingMessage();
    }
  });
});
